import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ComponentMessengerService } from './core/services/component-messenger.service';
import { InitializationService } from './core/services/initialization.service';
import { RouterOutlet } from '@angular/router';
import { InternalServerErrorPageComponent } from '../sb-tools/typescript/components/error-pages/internal-server-error-page/internal-server-error-page.component';
import { SimpleNotificationsModule } from 'angular2-notifications';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, InternalServerErrorPageComponent, SimpleNotificationsModule],
})
export class AppComponent implements OnInit {
    private messageSubscription: Subscription;
    isAppInitialized = false;
    title = 'app';

    constructor(
        private componentMessengerService: ComponentMessengerService,
        private initializationService: InitializationService,
    ) {
        this.isAppInitialized = !this.initializationService.initializeError;
    }

    ngOnInit() {
        this.messageSubscription = this.componentMessengerService.requestViewMessage.subscribe((isRequestOpened) => {
            const body = document.getElementsByTagName('body')[0];

            if (isRequestOpened === true) {
                body.classList.add('request-view-is-open');
            } else {
                setTimeout(() => {
                    // console.log('this.showRequestList()');
                    body.classList.remove('request-view-is-open');
                }, 200);
            }
        });
    }
}
